import React, { useState } from 'react';
import {
  IonTabs,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonIcon,
  IonLabel,
} from '@ionic/react';
import { Route, Redirect } from 'react-router';
import { calendar, informationCircle, people, storefront } from 'ionicons/icons';
import ShipmentPage from './ShipmentPage';
import InspectionPage from './InspectionPage';
import ShippingPage from './ShippingPage';
import StorePage from './StorePage';
import KoStorePage from './KoStorePage';

interface MainTabsProps {}

const MainTabs: React.FC<MainTabsProps> = () => {
  const handleTabChange = (event: CustomEvent) => {
  };

  return (
    <IonTabs>
      <IonRouterOutlet>
        <Redirect exact path="/tabs" to="/tabs/shipment" />
        <Route 
          path="/tabs/store" 
          render={() => <StorePage onTabChange={handleTabChange} />} 
          exact={true} 
        />
        <Route
          path="/tabs/shipment"
          render={() => <ShipmentPage onTabChange={handleTabChange} />}
          exact={true}
        />
        <Route
          path="/tabs/inspection"
          render={() => <InspectionPage onTabChange={handleTabChange} />}
          exact={true}
        />
        <Route 
          path="/tabs/shipping" 
          render={() => <ShippingPage onTabChange={handleTabChange} />} 
          exact={true} 
        />
        <Route 
          path="/tabs/kostore" 
          render={() => <KoStorePage onTabChange={handleTabChange} />} 
          exact={true} 
        />
      </IonRouterOutlet>
      <IonTabBar slot="bottom">
        <IonTabButton tab="store" href="/tabs/store">
          <IonIcon icon={storefront} />
          <IonLabel>入　庫</IonLabel>
        </IonTabButton>
        <IonTabButton tab="shipment" href="/tabs/shipment">
          <IonIcon icon={calendar} />
          <IonLabel>出　庫</IonLabel>
        </IonTabButton>
        <IonTabButton tab="inspection" href="/tabs/inspection">
          <IonIcon icon={informationCircle} />
          <IonLabel>検　品</IonLabel>
        </IonTabButton>
        <IonTabButton tab="shipping" href="/tabs/shipping">
          <IonIcon icon={people} />
          <IonLabel>出　荷</IonLabel>
        </IonTabButton>
        <IonTabButton tab="kostore" href="/tabs/kostore">
          <IonIcon icon={storefront} />
          <IonLabel>仮置き倉庫</IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
};

export default MainTabs;
